module.exports = __webpack_public_path__ + "static/UNITY-Tower-upper-floor-traditional_v2-ab444193af8413671170c59f27206d54.pdf";